"use client";

import { useCallback } from "react";
import { useTranslations } from "@zapier/i18n";
import { BULK_ASSET_ACTION_LIMIT, useNotification } from "@zapier/utils";

/** Notifies and returns true when `count` exceeds the bulk asset id limit. */
export function useBulkActionLimitGuard(action: "delete" | "restore") {
  const tDelete = useTranslations("bulk-delete-modal");
  const tRestore = useTranslations("buttons");
  const { createNotification } = useNotification();

  return useCallback(
    (count: number) => {
      if (count <= BULK_ASSET_ACTION_LIMIT) {
        return false;
      }
      createNotification(
        action === "delete"
          ? {
              title: tDelete("errors.title", { count }),
              message: tDelete("errors.limit-exceeded", {
                limit: BULK_ASSET_ACTION_LIMIT,
              }),
              type: "error",
            }
          : {
              message: tRestore("restore-limit-exceeded", {
                limit: BULK_ASSET_ACTION_LIMIT,
              }),
              type: "error",
            },
      );
      return true;
    },
    [action, createNotification, tDelete, tRestore],
  );
}
